(function () {
  function getOpenMenu() {
    return Array.prototype.find.call(document.querySelectorAll('[data-mega-menu][aria-hidden="false"]'), function (menu) {
      return menu.parentElement && menu.parentElement.classList.contains('is-dropdown-open');
    });
  }

  function ensureBackdrop() {
    var backdrop = document.querySelector('.mega-menu-backdrop');

    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'mega-menu-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.appendChild(backdrop);
    }

    if (backdrop.dataset.megaMenuBackdropReady !== 'true') {
      backdrop.dataset.megaMenuBackdropReady = 'true';

      backdrop.addEventListener('mouseenter', function () {
        var openMenu = getOpenMenu();
        if (openMenu) closeDesktopMenu(openMenu);
      });

      backdrop.addEventListener('click', function () {
        var openMenu = getOpenMenu();
        if (openMenu) closeDesktopMenu(openMenu);
      });
    }

    return backdrop;
  }

  function updateBackdrop() {
    var openMenu = getOpenMenu();
    var backdrop = ensureBackdrop();

    document.documentElement.classList.toggle('mega-menu-is-open', Boolean(openMenu));

    if (openMenu) {
      backdrop.style.top = Math.round(openMenu.getBoundingClientRect().top) + 'px';
    }
  }

  function closeMobileSearch() {
    var wrapper = document.querySelector('.header__search-bar-wrapper');

    if (!wrapper || (!wrapper.classList.contains('is-visible') && !wrapper.classList.contains('is-fixed'))) {
      return;
    }

    wrapper.classList.remove('is-visible', 'is-fixed');
    var header = document.querySelector('.header');

    if (header) {
      header.classList.remove('header--search-expanded');
    }

    document.body.classList.remove('no-mobile-scroll');

    if (document.querySelector('#mobile-menu[aria-hidden="false"]')) {
      document.body.classList.add('no-mobile-scroll');
    }
  }

  function initializeMobileHeader() {
    if (document.documentElement.dataset.mobileHeaderReady === 'true') {
      return;
    }

    document.documentElement.dataset.mobileHeaderReady = 'true';

    document.addEventListener('click', function (event) {
      var searchToggle = event.target.closest('[data-action="toggle-search"]');
      var menuToggle = event.target.closest('[data-action="toggle-menu"]');

      if (searchToggle) {
        window.setTimeout(function () {
          var wrapper = document.querySelector('.header__search-bar-wrapper');
          if (wrapper && !wrapper.classList.contains('is-visible')) closeMobileSearch();
        }, 0);
      }

      if (menuToggle) window.setTimeout(closeMobileSearch, 0);
    });
  }

  function initializeSearchCollectionFilter(root) {
    root.querySelectorAll('#search-product-collections').forEach(function (select) {
      if (select.dataset.searchCollectionReady === 'true') return;

      select.dataset.searchCollectionReady = 'true';
      select.addEventListener('change', function () {
        var search = select.closest('.search-bar') || document;
        var input = search.querySelector('.search-bar__input');
        var activeFilter = search.querySelector('.search-bar__filter-active');

        if (input) input.value = select.value;
        if (activeFilter) activeFilter.textContent = select.value;
      });
    });
  }

  function closeDesktopMenu(menu) {
    var owner = menu.parentElement;

    if (!owner) return;

    owner.classList.remove('is-dropdown-open');
    menu.setAttribute('aria-hidden', 'true');

    var trigger = owner.querySelector(':scope > [data-type="menuitem"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    var rootMenu = owner.closest('[data-type="menu"]');
    if (rootMenu) rootMenu.classList.remove('nav-dropdown--glued');
  }

  function openDesktopMenu(menu) {
    var owner = menu.parentElement;

    if (!owner) return;

    owner.parentElement.querySelectorAll(':scope > .is-dropdown-open').forEach(function (openOwner) {
      if (openOwner !== owner) {
        var openMenu = openOwner.querySelector(':scope > [data-mega-menu]');
        if (openMenu) closeDesktopMenu(openMenu);
      }
    });

    owner.classList.add('is-dropdown-open');
    menu.setAttribute('aria-hidden', 'false');

    var trigger = owner.querySelector(':scope > [data-type="menuitem"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    var rootMenu = owner.closest('[data-type="menu"]');
    if (rootMenu) rootMenu.classList.add('nav-dropdown--glued');
  }

  function updateMenuInteractivity(menu) {
    var owner = menu.parentElement;
    var isOpen = menu.getAttribute('aria-hidden') === 'false' && owner && owner.classList.contains('is-dropdown-open');

    if (isOpen) {
      menu.removeAttribute('inert');
    } else {
      menu.setAttribute('inert', '');
    }
  }

  function updateMenuPosition(menu) {
    if (menu.classList.contains('mega-menu--floating') || window.innerWidth < 1000) return;

    var infoBar = document.querySelector('[data-header-info-bar]');
    var infoBarHeight = infoBar && !infoBar.hidden ? infoBar.getBoundingClientRect().height : 0;
    menu.style.setProperty('--header-info-bar-height', Math.round(infoBarHeight) + 'px');

    var menuTop = menu.getBoundingClientRect().top;
    var curatedBarHeight = 60;
    menu.style.setProperty('--mega-menu-page-top', Math.round(menuTop) + 'px');
    menu.style.setProperty('--mega-menu-body-height', Math.max(360, Math.round(window.innerHeight - menuTop - curatedBarHeight)) + 'px');
  }

  function updateMenuPositions() {
    document.querySelectorAll('[data-mega-menu]').forEach(updateMenuPosition);
    updateBackdrop();
  }

  function initializeMenu(menu) {
    if (menu.dataset.megaMenuReady === 'true') return;

    menu.dataset.megaMenuReady = 'true';
    var owner = menu.parentElement;
    var trigger = owner && owner.querySelector(':scope > [data-type="menuitem"]');
    var hoverDelay = parseInt(menu.dataset.megaMenuHoverDelay, 10) || 0;
    var hoverOpenTimer = null;

    if (owner) owner.classList.add('nav-bar__item--static');

    updateMenuInteractivity(menu);
    updateMenuPosition(menu);

    if (trigger && menu.dataset.desktopOpenTrigger === 'hover' && hoverDelay > 0) {
      trigger.addEventListener('mouseover', function (event) {
        event.stopPropagation();

        if (event.relatedTarget && trigger.contains(event.relatedTarget)) return;
        if (owner.classList.contains('is-dropdown-open')) return;

        window.clearTimeout(hoverOpenTimer);
        hoverOpenTimer = window.setTimeout(function () {
          if (owner.matches(':hover')) openDesktopMenu(menu);
          hoverOpenTimer = null;
        }, hoverDelay);
      }, true);
    }

    if (owner) {
      owner.addEventListener('mouseleave', function (event) {
        if (event.relatedTarget && owner.contains(event.relatedTarget)) return;

        window.clearTimeout(hoverOpenTimer);
        hoverOpenTimer = null;

        window.setTimeout(function () {
          if (!owner.matches(':hover')) closeDesktopMenu(menu);
        }, 120);
      });
    }

    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        updateMenuInteractivity(menu);
        updateMenuPosition(menu);
        updateBackdrop();
      }).observe(menu, { attributes: true, attributeFilter: ['aria-hidden'] });

      if (owner) {
        new MutationObserver(function () {
          if (!owner.classList.contains('is-dropdown-open') && menu.getAttribute('aria-hidden') !== 'true') {
            menu.setAttribute('aria-hidden', 'true');
          }

          updateMenuInteractivity(menu);
          updateMenuPosition(menu);
          updateBackdrop();
        }).observe(owner, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  function initializeMenus(root) {
    root.querySelectorAll('[data-mega-menu]').forEach(initializeMenu);
  }

  function boot() {
    ensureBackdrop();
    initializeMobileHeader();
    initializeSearchCollectionFilter(document);
    initializeMenus(document);
    updateMenuPositions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeMobileHeader();
    initializeSearchCollectionFilter(event.target);
    initializeMenus(event.target);
    updateMenuPositions();
  });

  document.addEventListener('transitionend', function (event) {
    if (event.target.matches && event.target.matches('[data-header-info-bar]')) updateMenuPositions();
  });

  var resizeFrame;
  window.addEventListener('resize', function () {
    if (resizeFrame) return;

    resizeFrame = window.requestAnimationFrame(function () {
      resizeFrame = null;
      updateMenuPositions();
    });
  }, { passive: true });
})();
